import React from "react";
import { Lock, Flame, CheckCircle2 } from "lucide-react";

const MAP = {
  patreon_exclusive: {
    label: "Patreon Exclusive",
    Icon: Lock,
    classes: "bg-[#E50914]/10 text-[#E50914] border-[#E50914]/30",
    testid: "status-patreon",
  },
  unlock_in_progress: {
    label: "Unlock In Progress",
    Icon: Flame,
    classes: "bg-[#FF9F0A]/10 text-[#FF9F0A] border-[#FF9F0A]/30",
    testid: "status-progress",
  },
  unlocked: {
    label: "Unlocked",
    Icon: CheckCircle2,
    classes: "bg-[#32D74B]/10 text-[#32D74B] border-[#32D74B]/30",
    testid: "status-unlocked",
  },
};

export default function StatusBadge({ status, className = "" }) {
  const cfg = MAP[status] || MAP.patreon_exclusive;
  const { Icon } = cfg;
  return (
    <span
      data-testid={cfg.testid}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.18em] border ${cfg.classes} ${className}`}
    >
      <Icon className="w-3 h-3" strokeWidth={2.5} />
      {cfg.label}
    </span>
  );
}
